import React from 'react';

import { Badge, BadgeProps } from '@mui/material';

import LockIcon from './LockIcon';

interface Props extends BadgeProps {
    size?: number | string;
}

const LockIconBadge: React.FC<Props> = ({ children, size = 16, ...props }) => {
    return (
        <Badge
            {...props}
            slotProps={{ badge: { style: { right: -size / 2 } } }}
            badgeContent={<LockIcon size={size} />}
        >
            {children}
        </Badge>
    );
};

export default LockIconBadge;
